var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Table',{attrs:{"columns":_vm.columns,"data":_vm.messages,"loading":!_vm.pageLoader_isDataLoaded,"key-extractor":_vm.keyExtractor,"column-styles":{ message: 'width: 20%; font-size: 8px;' }},scopedSlots:_vm._u([{key:"message",fn:function(ref){
var message = ref.item;
return [_vm._v(_vm._s(message))]}},{key:"empty",fn:function(){return [_vm._v("Er zijn nog geen berichten")]},proxy:true}])})}
var staticRenderFns = []

export { render, staticRenderFns }